// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const ArticleCard = require('client-v2/common/components/cards/article')
// Sibling imports
const TopCallToActionExperimentBCollectionCard = require('./collection-card')

const bem = BemEntity('TopCallToActionExperimentBSplitTrailing')

function TopCallToActionExperimentBSplitTrailing(props) {
  return tag('div', {
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('item', 'collection')
    },
      tag(TopCallToActionExperimentBCollectionCard, {
        className: bem.element('card', 'collection'),
        // Values
        collection: props.collection,
        placeholderImage: props.placeholderImage,
        // Callbacks
        onFollowClick: props.onSignupClick
      }),
      tag('div', {
        className: bem.element('caption', 'collection')
      },
        `Discover the most interesting things\n`,
        `your friends are sharing`
      )
    ),

    tag('div', {
      className: bem.element('item', 'article')
    },
      tag(ArticleCard, {
        className: bem.element('card', 'article'),
        // Flags
        isHrefsEnabled: false,
        // Values
        article: props.article,
        placeholderImage: props.placeholderImage,
        // Callbacks
        onAddClick: props.onSignupClick
      }),
      tag('div', {
        className: bem.element('caption', 'article')
      },
        `Share your favorite websites,\n`,
        `articles, photos, and videos`
      )
    )
  )
}

module.exports = TopCallToActionExperimentBSplitTrailing
